/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Gettingstarted_Item41Inputs */

const he_help_gettingstarted_item41 = /** @type {(inputs: Help_Gettingstarted_Item41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חקרו את לוח הבקרה`)
};

const en_help_gettingstarted_item41 = /** @type {(inputs: Help_Gettingstarted_Item41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore the dashboard`)
};

/**
* | output |
* | --- |
* | "Explore the dashboard" |
*
* @param {Help_Gettingstarted_Item41Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const help_gettingstarted_item41 = /** @type {((inputs?: Help_Gettingstarted_Item41Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Gettingstarted_Item41Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_help_gettingstarted_item41(inputs)
	return en_help_gettingstarted_item41(inputs)
});
export { help_gettingstarted_item41 as "help_gettingStarted_item4" }